import type { CashDenominationRowDto } from './cash-denominations.dto.js';

export const cashTreasuryDistributionRequestStatusValues = [
  'requested',
  'accepted',
  'declined',
  'cancelled',
  'expired',
] as const;
export type CashTreasuryDistributionRequestStatus =
  (typeof cashTreasuryDistributionRequestStatusValues)[number];

// Monetary amounts are in minor units (e.g., cents).
export interface CashTreasuryDistributionRequestDto {
  id: string;
  companyId: string;
  idempotencyKey: string;
  treasuryCashLocationId: string;
  targetCashLocationId: string;
  targetStoreId: string;
  targetLocationId: string;
  targetStationId: string;
  amountMinor: number;
  denominations: CashDenominationRowDto[] | null;
  status: CashTreasuryDistributionRequestStatus;
  requestedByUserId: string;
  acceptedByUserId: string | null;
  declinedByUserId: string | null;
  cancelledByUserId: string | null;
  requestedAt: string;
  acceptedAt: string | null;
  declinedAt: string | null;
  cancelledAt: string | null;
  expiredAt: string | null;
  expiresAt: string | null;
  requestNote: string | null;
  declineReason: string | null;
  cancellationReason: string | null;
  ledgerAppliedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCashTreasuryDistributionRequestRequest {
  companyId: string;
  operationId: string;
  occurredAt?: string;
  idempotencyKey: string;
  treasuryCashLocationId: string;
  targetCashLocationId: string;
  targetStationId: string;
  amountMinor: number;
  denominations?: CashDenominationRowDto[] | null;
  note?: string | null;
  expiresAt?: string | null;
}

export interface CreateCashTreasuryDistributionRequestResponse {
  request: CashTreasuryDistributionRequestDto;
}

export interface GetCashTreasuryDistributionRequestRequest {
  companyId: string;
  cashTreasuryDistributionRequestId: string;
}

export interface CancelCashTreasuryDistributionRequestRequest {
  companyId: string;
  operationId: string;
  occurredAt?: string;
  cashTreasuryDistributionRequestId: string;
  reason?: string | null;
}

export interface DeclineCashTreasuryDistributionRequestRequest {
  companyId: string;
  operationId: string;
  treasuryInstructionId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  reason: string;
  occurredAt?: string;
}

export interface ListCashTreasuryDistributionRequestsRequest {
  companyId: string;
  treasuryCashLocationId?: string;
  targetCashLocationId?: string;
  targetStationId?: string;
  status?: CashTreasuryDistributionRequestStatus;
  requestedFrom?: string;
  requestedTo?: string;
}

export interface ListCashTreasuryDistributionRequestsResponse {
  items: CashTreasuryDistributionRequestDto[];
}

export interface GetCashTreasuryDistributionAvailabilityRequest {
  companyId: string;
  treasuryCashLocationId: string;
  targetStationId?: string;
}

export interface GetCashTreasuryDistributionAvailabilityResponse {
  companyId: string;
  treasuryCashLocationId: string;
  targetStationId: string | null;
  currentBalanceMinor: number;
  reservedDistributionAmountMinor: number;
  availableBalanceMinor: number;
  cloudLedgerAsOf: string;
  lastCloudCashMovementAt: string | null;
  targetStationLastUploadAt: string | null;
}
